import { Epic } from 'redux-observable';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';
import { isActionOf } from 'typesafe-actions';
import { RootDependencies } from '../dependencies';
import { RootState } from '../reducer';
import { RootAction } from '../actions';
import { fetchBuildingSettings } from './actions';

export const fetchBuildingSettingsEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(fetchBuildingSettings.request)),
    withLatestFrom(state$),
    switchMap(([action, state]) =>
      apiClient(state)
        .getBuildingSettings(action.payload.buildingUuid)
        .pipe(
          map((response) => fetchBuildingSettings.success({ params: action.payload, response: response.response })),
          catchError((error: Error) => {
            return of(fetchBuildingSettings.failure({ params: action.payload, response: error }));
          }),
        ),
    ),
  );
